import { ActionMeta } from "../../../model/ActionMeta";
import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_SHOP = "SHOP:UPSERT_SHOP";

export const upsertShopAction = (
  organization: OrganizationKeyName,
  data: any,
  id?: string,
  meta?: ActionMeta
) => ({
  type: UPSERT_SHOP as typeof UPSERT_SHOP,
  organization,
  data,
  id,
  meta,
});

export type UpsertShopAction = ReturnType<typeof upsertShopAction>;
